import axios from "axios";
import envConfig from "../config";
import ServiceHelper from "./serviceHelper";

class NotificationService {
  static GetNotifications() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/notification/notifications`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static GetTriggeredNotifications() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/notification/triggered`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static AddNotification(notification) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/notification/add`, notification, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static UpdateNotification(notification) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/notification/update`, notification, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static DeleteNotification(notificationExternalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/notification/delete/${notificationExternalId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static SnoozeNotification(notificationExternalId, days) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(
        `${envConfig.apiBaseUrl}/api/notification/snooze/${notificationExternalId}`,
        { days },
        config,
      )
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static ClearSnooze(notificationExternalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(
        `${envConfig.apiBaseUrl}/api/notification/clearsnooze/${notificationExternalId}`,
        null,
        config,
      )
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }
}

export default NotificationService;
